import { FC } from 'react'
import styles from './Hero.module.scss'
import { ResponsiveVideo } from 'components/basic/Video'
import { Img } from 'components/basic/Img/Img'

const videos = [
	{
		url: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-hero-taylor-fritz.mp4',
		breakpoint: 0,
		x: 374,
		y: 474,
		thumb: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-hero-video-thumb-mobile.jpg',
	},
	{
		url: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-hero-taylor-fritz.mp4',
		breakpoint: 600,
		x: 1189,
		y: 495.41,
		thumb: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes-hero-video-thumb-desktop.jpg',
	},
]

export const Hero: FC = () => {
	const onScrollDown = () => {
		window.scroll({
			top: window.innerHeight,
			behavior: 'smooth',
		})
	}

	return (
		<section className={styles.root}>
			<div className={styles.video_container}>
				<ResponsiveVideo
					videos={videos}
					caption="The athletes"
				/>
			</div>

			<div className={styles.content_container}>
				<div className={styles.title}>Peak performance begins with revolutionary rest</div>
				<div className={styles.subtitle}>Discover why champions choose Eight Sleep</div>
			</div>

			<Img
				src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/athletes/arrow_down_circle.svg"
				alt="scroll down"
				className={styles.scroll_down}
				onClick={onScrollDown}
			/>
		</section>
	)
}
